import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { colors } from '../common';
export var ProgressCircle = function (_a) {
    var percentage = _a.percentage, label = _a.label, color = _a.color, children = _a.children, footer = _a.footer;
    var classes = useStyles({ color: color });
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: "bar-overflow" },
            React.createElement("div", { className: "bar", style: { transform: "rotate(" + (45 + (percentage * 1.8)) + "deg)" } }),
            React.createElement("div", { className: "inner-text" }, children),
            React.createElement("div", { className: "inner-footer", title: footer }, footer)),
        React.createElement("span", { className: "label" }, label)));
};
var useStyles = makeStyles({
    root: {
        position: 'relative',
        margin: '.25em',
        float: 'left',
        textAlign: 'center',
        "& .bar-overflow": {
            position: 'relative',
            overflow: 'hidden',
            width: '12em',
            height: '6em',
            marginBottom: '-1em',
            "& .bar": {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '12em',
                height: '12em',
                borderRadius: '50%',
                boxSizing: 'border-box',
                border: '.3em solid',
                borderColor: colors.lightGrey,
                borderBottomColor: function (_a) {
                    var color = _a.color;
                    return colors[color] || colors.yellow;
                },
                borderRightColor: function (_a) {
                    var color = _a.color;
                    return colors[color] || colors.yellow;
                },
            },
            "& .inner-text": {
                fontWeight: 500,
                position: 'absolute',
                top: '2em',
                left: 0,
                width: '12em'
            },
            "& .inner-footer": {
                fontWeight: 500,
                position: 'absolute',
                top: '3.5em',
                left: 0,
                width: '12em',
                height: 19,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
        },
        "& .label": {
            textTransform: 'uppercase',
            fontSize: 10
        }
    }
});
//# sourceMappingURL=progressCircle.js.map